import { render, staticRenderFns } from "./OpportunityQuery.vue?vue&type=template&id=468c0597&scoped=true&"
import script from "./OpportunityQuery.vue?vue&type=script&lang=js&"
export * from "./OpportunityQuery.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityQuery.vue?vue&type=style&index=0&id=468c0597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c0597",
  null
  
)

export default component.exports